import axios from "axios";

export class S3 {
  // Turn a presigned S3 URL + object key into the canonical s3://<bucket>/<key>
  // reference the backend stores and validates.
  //   virtual-hosted: https://<bucket>.s3.<region>.amazonaws.com/<key>?...
  //   path-style:     https://s3.<region>.amazonaws.com/<bucket>/<key>?...
  static toS3Uri(presignedUrl: string, key: string): string {
    const url = new URL(presignedUrl);
    const bucket = url.hostname.includes(".s3")
      ? url.hostname.split(".s3")[0]
      : url.pathname.split("/").filter(Boolean)[0];

    return `s3://${bucket}/${key}`;
  }

  static async fetchS3JsonFile<T>(s3Url: string): Promise<T> {
    const response = await axios.get<T>(s3Url, {
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
      },
    });

    return response.data;
  }
}
